module.exports = __webpack_public_path__ + "static/img/qianyue1.7cbb473.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/qianyue1.png
// module id = 5vvP
// module chunks = 1